export const OVERALL_MARKET_SEGMENT_LABEL = 'Overall Market Segment';

// The overall segment's id is `default`, and its stored name is often that same raw id.
// Show the product label in that case. A real rename of the segment still wins, and every
// other segment name is returned unchanged.
export function marketSegmentDisplayName(segmentId, segmentName) {
  const id = typeof segmentId === 'string' ? segmentId.trim().toLowerCase() : '';
  const name = typeof segmentName === 'string' ? segmentName : '';
  const comparable = name.trim().toLowerCase();
  if (id === 'default' && (comparable === '' || comparable === 'default')) {
    return OVERALL_MARKET_SEGMENT_LABEL;
  }
  return name;
}

export function toMarketShareSegmentOption(segment) {
  const segmentId = segment?.segment_id;
  const segmentName = segment?.segment_name;
  return {
    text: marketSegmentDisplayName(segmentId, segmentName) || segmentName,
    value: segmentId,
    type: 'market_share_segment',
  };
}

// Chip label: the live option list wins over a name frozen into a link, then the raw
// overall-segment id is shown as the product label.
export function resolveMarketSegmentChipLabel(selectedSegment, options) {
  const storedLabel = selectedSegment?.text;
  const value = selectedSegment?.value;
  const liveOption = value ? (options || []).find((option) => option && option.value === value) : null;
  const rawLabel = liveOption?.text || storedLabel;
  return marketSegmentDisplayName(value, rawLabel) || rawLabel || OVERALL_MARKET_SEGMENT_LABEL;
}
